module.exports = __webpack_public_path__ + "img/flowGroupWhite.1d171528.png";